import {
    TransactionDetails,
    TransactionStatus,
    NotificationStatus,
} from '../../../../../projects/ach-transaction-details/src/lib/models'

export const SETTLED_TRANSACTION: TransactionDetails = {
    transactionId: '583914245518940015',
    processorTransactionId: 'ACH20260115583914245',
    amount: 1250.00,
    status: TransactionStatus.Settled,
    effectiveDate: '2026-01-15',
    settlementDate: '2026-01-17',

    subMerchantName: 'Bright Smiles Dental Group',
    subMerchantId: 'MER-7291-BSDG',
    accountHolderName: 'Margaret Chen',
    transactionDate: '2026-01-15',
    transactionType: 'Debit',
    submittedBy: 'Sarah Johnson',
    product: 'WellfitPay',
    originType: 'WEB',
    bankAccountType: 'Checking',
    maskedAccountNumber: '****4821',
    routingNumber: '021000021',

    authorizationType: 'Electronic',
    authorizationDateTime: '2026-01-15T09:34:12',
    authorizationReference: 'AUTH-REF-58391',
    authorizationReferenceDate: '2026-01-15',

    returnDate: null,
    returnReasonCode: null,
    returnReasonDescription: null,
    retryAttempt: null,

    nocCode: null,
    nocDescription: null,
    nocDate: null,

    refundInfo: null,

    relatedTransactions: [
        {
            transactionId: '583914245518940008',
            transactionDate: '2025-12-15',
            amount: 1250.00,
            status: TransactionStatus.Settled,
            relationship: 'Previous Payment',
        },
    ],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-01-15T09:35:00',
            recipient: 'margaret.chen@gmail.com',
            status: NotificationStatus.Delivered,
            templateType: 'Authorization',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260115-00421/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2026-01-15T09:35:02',
            recipient: 'margaret.chen@gmail.com',
            status: NotificationStatus.Delivered,
            templateType: 'Payment Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260115-00422/content',
        },
        {
            notificationType: 'SMS',
            sentDateTime: '2026-01-15T09:35:05',
            recipient: '+1***-***-8834',
            status: NotificationStatus.Delivered,
            templateType: 'Payment Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/SMS-REF-20260115-00198/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-01-15T09:34:12',
            updatedBy: 'Sarah Johnson',
        },
        {
            achStatus: TransactionStatus.Approved,
            dateTime: '2026-01-15T10:01:33',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Settled,
            dateTime: '2026-01-17T06:15:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Funded,
            dateTime: '2026-01-17T14:30:45',
            updatedBy: 'System',
        },
    ],
    exportHistory: [
        {
            userName: 'David Kim',
            timeStamp: '2026-01-18T11:22:09',
        },
    ],
}

export const RETURNED_TRANSACTION: TransactionDetails = {
    transactionId: '604827319042760023',
    processorTransactionId: 'ACH20260210604827319',
    amount: 875.50,
    status: TransactionStatus.Returned,
    effectiveDate: '2026-02-10',
    settlementDate: null,

    subMerchantName: 'Lakewood Family Dentistry',
    subMerchantId: 'MER-3054-LFD',
    accountHolderName: 'James Rodriguez',
    transactionDate: '2026-02-10',
    transactionType: 'Debit',
    submittedBy: 'Michael Torres',
    product: 'WellfitPay',
    originType: 'WEB',
    bankAccountType: 'Checking',
    maskedAccountNumber: '****6193',
    routingNumber: '071000013',

    authorizationType: 'Electronic',
    authorizationDateTime: '2026-02-10T14:18:55',
    authorizationReference: 'AUTH-REF-60482',
    authorizationReferenceDate: '2026-02-10',

    returnDate: '2026-02-12',
    returnReasonCode: 'R01',
    returnReasonDescription: 'Insufficient Funds',
    retryAttempt: '2 remaining',

    nocCode: null,
    nocDescription: null,
    nocDate: null,

    refundInfo: null,

    relatedTransactions: [],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-02-10T14:19:30',
            recipient: 'j.rodriguez@outlook.com',
            status: NotificationStatus.Delivered,
            templateType: 'Authorization',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260210-00587/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2026-02-12T08:45:12',
            recipient: 'j.rodriguez@outlook.com',
            status: NotificationStatus.Failed,
            templateType: 'Return Notice',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260212-00093/content',
        },
        {
            notificationType: 'SMS',
            sentDateTime: '2026-02-12T08:45:15',
            recipient: '+1***-***-4207',
            status: NotificationStatus.Delivered,
            templateType: 'Return Notice',
            referenceId: 'https://comms.wellfit.com/notifications/SMS-REF-20260212-00041/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-02-10T14:18:55',
            updatedBy: 'Michael Torres',
        },
        {
            achStatus: TransactionStatus.Approved,
            dateTime: '2026-02-10T15:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Returned,
            dateTime: '2026-02-12T08:44:30',
            updatedBy: 'System',
        },
    ],
    exportHistory: [],
}

export const WITH_REFUND_TRANSACTION: TransactionDetails = {
    transactionId: '719503682114380041',
    processorTransactionId: 'ACH20260305719503682',
    amount: 2400.00,
    status: TransactionStatus.Settled,
    effectiveDate: '2026-03-05',
    settlementDate: '2026-03-07',

    subMerchantName: 'Summit Orthodontics',
    subMerchantId: 'MER-8812-SORT',
    accountHolderName: 'Patricia Nguyen',
    transactionDate: '2026-03-05',
    transactionType: 'Debit',
    submittedBy: 'Lisa Park',
    product: 'WellfitPay',
    originType: 'PPD',
    bankAccountType: 'Savings',
    maskedAccountNumber: '****7350',
    routingNumber: '091000019',

    authorizationType: 'Verbal',
    authorizationDateTime: '2026-03-05T11:02:44',
    authorizationReference: 'CALL-REC-71950',
    authorizationReferenceDate: '2026-03-05',

    returnDate: null,
    returnReasonCode: null,
    returnReasonDescription: null,
    retryAttempt: null,

    nocCode: null,
    nocDescription: null,
    nocDate: null,

    refundInfo: [
        {
            refundTransactionId: '719503682114380055',
            refundNotificationType: 'Email',
            refundDate: '2026-03-12',
            refundAmount: 800.00,
            refundBy: 'Lisa Park',
        },
        {
            refundTransactionId: '719503682114380068',
            refundNotificationType: 'Email',
            refundDate: '2026-03-18',
            refundAmount: 400.00,
            refundBy: 'Lisa Park',
        },
    ],

    relatedTransactions: [
        {
            transactionId: '719503682114380055',
            transactionDate: '2026-03-12',
            amount: 800.00,
            status: TransactionStatus.Settled,
            relationship: 'Refund',
        },
        {
            transactionId: '719503682114380068',
            transactionDate: '2026-03-18',
            amount: 400.00,
            status: TransactionStatus.Pending,
            relationship: 'Refund',
        },
    ],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-03-05T11:03:10',
            recipient: 'p.nguyen@yahoo.com',
            status: NotificationStatus.Delivered,
            templateType: 'Authorization',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260305-00712/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2026-03-05T11:03:12',
            recipient: 'p.nguyen@yahoo.com',
            status: NotificationStatus.Delivered,
            templateType: 'Payment Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260305-00713/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2026-03-12T09:15:00',
            recipient: 'p.nguyen@yahoo.com',
            status: NotificationStatus.Delivered,
            templateType: 'Refund Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260312-00154/content',
        },
        {
            notificationType: 'SMS',
            sentDateTime: '2026-03-12T09:15:03',
            recipient: '+1***-***-5521',
            status: NotificationStatus.Delivered,
            templateType: 'Refund Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/SMS-REF-20260312-00067/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-03-05T11:02:44',
            updatedBy: 'Lisa Park',
        },
        {
            achStatus: TransactionStatus.Approved,
            dateTime: '2026-03-05T11:30:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Settled,
            dateTime: '2026-03-07T06:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Funded,
            dateTime: '2026-03-07T15:00:00',
            updatedBy: 'System',
        },
    ],
    exportHistory: [
        {
            userName: 'Lisa Park',
            timeStamp: '2026-03-08T10:05:33',
        },
        {
            userName: 'Robert Walsh',
            timeStamp: '2026-03-13T16:42:17',
        },
    ],
}

export const WITH_NOC_TRANSACTION: TransactionDetails = {
    transactionId: '835290146738520009',
    processorTransactionId: 'ACH20260120835290146',
    amount: 550.00,
    status: TransactionStatus.Settled,
    effectiveDate: '2026-01-20',
    settlementDate: '2026-01-22',

    subMerchantName: 'Cedar Point Dental Care',
    subMerchantId: 'MER-5567-CPDC',
    accountHolderName: 'William Thompson',
    transactionDate: '2026-01-20',
    transactionType: 'Debit',
    submittedBy: 'Sarah Johnson',
    product: 'WellfitPay',
    originType: 'CCD',
    bankAccountType: 'Checking',
    maskedAccountNumber: '****2048',
    routingNumber: '031000053',

    authorizationType: 'Electronic',
    authorizationDateTime: '2026-01-20T16:45:30',
    authorizationReference: null,
    authorizationReferenceDate: null,

    returnDate: null,
    returnReasonCode: null,
    returnReasonDescription: null,
    retryAttempt: null,

    nocCode: 'C01',
    nocDescription: 'Incorrect DFI Account Number',
    nocDate: '2026-01-23',

    refundInfo: null,

    relatedTransactions: [],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-01-20T16:46:00',
            recipient: 'w.thompson@protonmail.com',
            status: NotificationStatus.Delivered,
            templateType: 'Authorization',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260120-00331/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2026-01-23T07:30:00',
            recipient: 'billing@cedarpointdental.com',
            status: NotificationStatus.Delivered,
            templateType: 'NOC Alert',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260123-00042/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-01-20T16:45:30',
            updatedBy: 'Sarah Johnson',
        },
        {
            achStatus: TransactionStatus.Approved,
            dateTime: '2026-01-20T17:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Settled,
            dateTime: '2026-01-22T06:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Funded,
            dateTime: '2026-01-22T14:15:00',
            updatedBy: 'System',
        },
    ],
    exportHistory: [],
}

export const MULTI_DYNAMIC_TRANSACTION: TransactionDetails = {
    transactionId: '947061538291640037',
    processorTransactionId: 'ACH20260401947061538',
    amount: 3200.00,
    status: TransactionStatus.Returned,
    effectiveDate: '2026-04-01',
    settlementDate: '2026-04-03',

    subMerchantName: 'Pinnacle Periodontics',
    subMerchantId: 'MER-1193-PP',
    accountHolderName: 'Elizabeth Foster',
    transactionDate: '2026-04-01',
    transactionType: 'Debit',
    submittedBy: 'Amanda Cruz',
    product: 'WellfitPay',
    originType: 'TEL',
    bankAccountType: 'Checking',
    maskedAccountNumber: '****9174',
    routingNumber: '041000124',

    authorizationType: 'Verbal',
    authorizationDateTime: '2026-04-01T08:12:05',
    authorizationReference: 'CALL-REC-94706',
    authorizationReferenceDate: '2026-04-01',

    returnDate: '2026-04-05',
    returnReasonCode: 'R10',
    returnReasonDescription: 'Customer Advises Originator is Not Known to Receiver and/or Is Not Authorized by Receiver to Debit Receiver\'s Account',
    retryAttempt: '2 remaining',

    nocCode: 'C05',
    nocDescription: 'Incorrect Transaction Code',
    nocDate: '2026-04-04',

    refundInfo: [
        {
            refundTransactionId: '947061538291640051',
            refundNotificationType: 'Email',
            refundDate: '2026-04-08',
            refundAmount: 1600.00,
            refundBy: 'Amanda Cruz',
        },
    ],

    relatedTransactions: [
        {
            transactionId: '947061538291640051',
            transactionDate: '2026-04-08',
            amount: 1600.00,
            status: TransactionStatus.Settled,
            relationship: 'Refund',
        },
        {
            transactionId: '947061538291640020',
            transactionDate: '2026-03-01',
            amount: 3200.00,
            status: TransactionStatus.Settled,
            relationship: 'Previous Payment',
        },
        {
            transactionId: '947061538291640065',
            transactionDate: '2026-04-10',
            amount: 1600.00,
            status: TransactionStatus.Pending,
            relationship: 'Refund',
        },
    ],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-04-01T08:13:00',
            recipient: 'e.foster@icloud.com',
            status: NotificationStatus.Delivered,
            templateType: 'Authorization',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260401-00102/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2026-04-04T07:00:00',
            recipient: 'billing@pinnacleperio.com',
            status: NotificationStatus.Delivered,
            templateType: 'NOC Alert',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260404-00018/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2026-04-05T09:30:00',
            recipient: 'e.foster@icloud.com',
            status: NotificationStatus.Failed,
            templateType: 'Return Notice',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260405-00074/content',
        },
        {
            notificationType: 'SMS',
            sentDateTime: '2026-04-05T09:30:05',
            recipient: '+1***-***-3301',
            status: NotificationStatus.Delivered,
            templateType: 'Return Notice',
            referenceId: 'https://comms.wellfit.com/notifications/SMS-REF-20260405-00029/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2026-04-08T10:00:00',
            recipient: 'e.foster@icloud.com',
            status: NotificationStatus.Pending,
            templateType: 'Refund Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260408-00211/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-04-01T08:12:05',
            updatedBy: 'Amanda Cruz',
        },
        {
            achStatus: TransactionStatus.Approved,
            dateTime: '2026-04-01T09:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Settled,
            dateTime: '2026-04-03T06:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Funded,
            dateTime: '2026-04-03T14:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Returned,
            dateTime: '2026-04-05T09:29:00',
            updatedBy: 'System',
        },
    ],
    exportHistory: [
        {
            userName: 'Amanda Cruz',
            timeStamp: '2026-04-02T09:00:00',
        },
        {
            userName: 'David Kim',
            timeStamp: '2026-04-06T11:30:00',
        },
        {
            userName: 'Sarah Johnson',
            timeStamp: '2026-04-09T14:15:00',
        },
    ],
}

export const SETTLED_PREVIOUS_PAYMENT: TransactionDetails = {
    transactionId: '583914245518940008',
    processorTransactionId: 'ACH20251215583914245',
    amount: 1250.00,
    status: TransactionStatus.Settled,
    effectiveDate: '2025-12-15',
    settlementDate: '2025-12-17',

    subMerchantName: 'Bright Smiles Dental Group',
    subMerchantId: 'MER-7291-BSDG',
    accountHolderName: 'Margaret Chen',
    transactionDate: '2025-12-15',
    transactionType: 'Debit',
    submittedBy: 'Sarah Johnson',
    product: 'WellfitPay',
    originType: 'WEB',
    bankAccountType: 'Checking',
    maskedAccountNumber: '****4821',
    routingNumber: '021000021',

    authorizationType: 'Electronic',
    authorizationDateTime: '2025-12-15T10:22:08',
    authorizationReference: 'AUTH-REF-58391-P',
    authorizationReferenceDate: '2025-12-15',

    returnDate: null,
    returnReasonCode: null,
    returnReasonDescription: null,
    retryAttempt: null,

    nocCode: null,
    nocDescription: null,
    nocDate: null,

    refundInfo: null,

    relatedTransactions: [],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2025-12-15T10:22:45',
            recipient: 'margaret.chen@gmail.com',
            status: NotificationStatus.Delivered,
            templateType: 'Authorization',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20251215-00318/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2025-12-15T10:22:47',
            recipient: 'margaret.chen@gmail.com',
            status: NotificationStatus.Delivered,
            templateType: 'Payment Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20251215-00319/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2025-12-15T10:22:08',
            updatedBy: 'Sarah Johnson',
        },
        {
            achStatus: TransactionStatus.Approved,
            dateTime: '2025-12-15T10:45:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Settled,
            dateTime: '2025-12-17T06:10:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Funded,
            dateTime: '2025-12-17T14:20:00',
            updatedBy: 'System',
        },
    ],
    exportHistory: [],
}

export const REFUND_SETTLED: TransactionDetails = {
    transactionId: '719503682114380055',
    processorTransactionId: 'ACH20260312719503682',
    amount: 800.00,
    status: TransactionStatus.Settled,
    effectiveDate: '2026-03-12',
    settlementDate: '2026-03-14',

    subMerchantName: 'Summit Orthodontics',
    subMerchantId: 'MER-8812-SORT',
    accountHolderName: 'Patricia Nguyen',
    transactionDate: '2026-03-12',
    transactionType: 'Refund',
    submittedBy: 'Lisa Park',
    product: 'WellfitPay',
    originType: 'PPD',
    bankAccountType: 'Savings',
    maskedAccountNumber: '****7350',
    routingNumber: '091000019',

    authorizationType: 'Electronic',
    authorizationDateTime: '2026-03-12T09:10:05',
    authorizationReference: 'AUTH-REF-71950-R1',
    authorizationReferenceDate: '2026-03-12',

    returnDate: null,
    returnReasonCode: null,
    returnReasonDescription: null,
    retryAttempt: null,

    nocCode: null,
    nocDescription: null,
    nocDate: null,

    refundInfo: null,

    relatedTransactions: [],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-03-12T09:15:00',
            recipient: 'p.nguyen@yahoo.com',
            status: NotificationStatus.Delivered,
            templateType: 'Refund Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260312-00154/content',
        },
        {
            notificationType: 'SMS',
            sentDateTime: '2026-03-12T09:15:03',
            recipient: '+1***-***-5521',
            status: NotificationStatus.Delivered,
            templateType: 'Refund Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/SMS-REF-20260312-00067/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-03-12T09:10:05',
            updatedBy: 'Lisa Park',
        },
        {
            achStatus: TransactionStatus.Approved,
            dateTime: '2026-03-12T09:30:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Settled,
            dateTime: '2026-03-14T06:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Funded,
            dateTime: '2026-03-14T14:45:00',
            updatedBy: 'System',
        },
    ],
    exportHistory: [],
}

export const REFUND_PENDING: TransactionDetails = {
    transactionId: '719503682114380068',
    processorTransactionId: 'ACH20260318719503682',
    amount: 400.00,
    status: TransactionStatus.Pending,
    effectiveDate: '2026-03-18',
    settlementDate: null,

    subMerchantName: 'Summit Orthodontics',
    subMerchantId: 'MER-8812-SORT',
    accountHolderName: 'Patricia Nguyen',
    transactionDate: '2026-03-18',
    transactionType: 'Refund',
    submittedBy: 'Lisa Park',
    product: 'WellfitPay',
    originType: 'PPD',
    bankAccountType: 'Savings',
    maskedAccountNumber: '****7350',
    routingNumber: '091000019',

    authorizationType: 'Electronic',
    authorizationDateTime: '2026-03-18T14:05:22',
    authorizationReference: 'AUTH-REF-71950-R2',
    authorizationReferenceDate: '2026-03-18',

    returnDate: null,
    returnReasonCode: null,
    returnReasonDescription: null,
    retryAttempt: null,

    nocCode: null,
    nocDescription: null,
    nocDate: null,

    refundInfo: null,

    relatedTransactions: [],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-03-18T14:06:00',
            recipient: 'p.nguyen@yahoo.com',
            status: NotificationStatus.Pending,
            templateType: 'Refund Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260318-00089/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-03-18T14:05:22',
            updatedBy: 'Lisa Park',
        },
    ],
    exportHistory: [],
}

export const MULTI_REFUND_SETTLED: TransactionDetails = {
    transactionId: '947061538291640051',
    processorTransactionId: 'ACH20260408947061538',
    amount: 1600.00,
    status: TransactionStatus.Settled,
    effectiveDate: '2026-04-08',
    settlementDate: '2026-04-10',

    subMerchantName: 'Pinnacle Periodontics',
    subMerchantId: 'MER-1193-PP',
    accountHolderName: 'Elizabeth Foster',
    transactionDate: '2026-04-08',
    transactionType: 'Refund',
    submittedBy: 'Amanda Cruz',
    product: 'WellfitPay',
    originType: 'TEL',
    bankAccountType: 'Checking',
    maskedAccountNumber: '****9174',
    routingNumber: '041000124',

    authorizationType: 'Electronic',
    authorizationDateTime: '2026-04-08T09:55:14',
    authorizationReference: 'AUTH-REF-94706-R1',
    authorizationReferenceDate: '2026-04-08',

    returnDate: null,
    returnReasonCode: null,
    returnReasonDescription: null,
    retryAttempt: null,

    nocCode: null,
    nocDescription: null,
    nocDate: null,

    refundInfo: null,

    relatedTransactions: [],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-04-08T10:00:00',
            recipient: 'e.foster@icloud.com',
            status: NotificationStatus.Delivered,
            templateType: 'Refund Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260408-00211/content',
        },
        {
            notificationType: 'SMS',
            sentDateTime: '2026-04-08T10:00:04',
            recipient: '+1***-***-3301',
            status: NotificationStatus.Delivered,
            templateType: 'Refund Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/SMS-REF-20260408-00083/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-04-08T09:55:14',
            updatedBy: 'Amanda Cruz',
        },
        {
            achStatus: TransactionStatus.Approved,
            dateTime: '2026-04-08T10:15:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Settled,
            dateTime: '2026-04-10T06:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Funded,
            dateTime: '2026-04-10T14:30:00',
            updatedBy: 'System',
        },
    ],
    exportHistory: [],
}

export const MULTI_PREVIOUS_PAYMENT: TransactionDetails = {
    transactionId: '947061538291640020',
    processorTransactionId: 'ACH20260301947061538',
    amount: 3200.00,
    status: TransactionStatus.Settled,
    effectiveDate: '2026-03-01',
    settlementDate: '2026-03-03',

    subMerchantName: 'Pinnacle Periodontics',
    subMerchantId: 'MER-1193-PP',
    accountHolderName: 'Elizabeth Foster',
    transactionDate: '2026-03-01',
    transactionType: 'Debit',
    submittedBy: 'Amanda Cruz',
    product: 'WellfitPay',
    originType: 'TEL',
    bankAccountType: 'Checking',
    maskedAccountNumber: '****9174',
    routingNumber: '041000124',

    authorizationType: 'Verbal',
    authorizationDateTime: '2026-03-01T11:30:42',
    authorizationReference: 'CALL-REC-94706-P',
    authorizationReferenceDate: '2026-03-01',

    returnDate: null,
    returnReasonCode: null,
    returnReasonDescription: null,
    retryAttempt: null,

    nocCode: null,
    nocDescription: null,
    nocDate: null,

    refundInfo: null,

    relatedTransactions: [],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-03-01T11:31:10',
            recipient: 'e.foster@icloud.com',
            status: NotificationStatus.Delivered,
            templateType: 'Authorization',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260301-00074/content',
        },
        {
            notificationType: 'Email',
            sentDateTime: '2026-03-01T11:31:12',
            recipient: 'e.foster@icloud.com',
            status: NotificationStatus.Delivered,
            templateType: 'Payment Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260301-00075/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-03-01T11:30:42',
            updatedBy: 'Amanda Cruz',
        },
        {
            achStatus: TransactionStatus.Approved,
            dateTime: '2026-03-01T12:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Settled,
            dateTime: '2026-03-03T06:00:00',
            updatedBy: 'System',
        },
        {
            achStatus: TransactionStatus.Funded,
            dateTime: '2026-03-03T14:00:00',
            updatedBy: 'System',
        },
    ],
    exportHistory: [],
}

export const MULTI_REFUND_PENDING: TransactionDetails = {
    transactionId: '947061538291640065',
    processorTransactionId: 'ACH20260410947061538',
    amount: 1600.00,
    status: TransactionStatus.Pending,
    effectiveDate: '2026-04-10',
    settlementDate: null,

    subMerchantName: 'Pinnacle Periodontics',
    subMerchantId: 'MER-1193-PP',
    accountHolderName: 'Elizabeth Foster',
    transactionDate: '2026-04-10',
    transactionType: 'Refund',
    submittedBy: 'Amanda Cruz',
    product: 'WellfitPay',
    originType: 'TEL',
    bankAccountType: 'Checking',
    maskedAccountNumber: '****9174',
    routingNumber: '041000124',

    authorizationType: 'Electronic',
    authorizationDateTime: '2026-04-10T13:40:18',
    authorizationReference: 'AUTH-REF-94706-R2',
    authorizationReferenceDate: '2026-04-10',

    returnDate: null,
    returnReasonCode: null,
    returnReasonDescription: null,
    retryAttempt: null,

    nocCode: null,
    nocDescription: null,
    nocDate: null,

    refundInfo: null,

    relatedTransactions: [],
    notifications: [
        {
            notificationType: 'Email',
            sentDateTime: '2026-04-10T13:41:00',
            recipient: 'e.foster@icloud.com',
            status: NotificationStatus.Pending,
            templateType: 'Refund Confirmation',
            referenceId: 'https://comms.wellfit.com/notifications/EMAIL-REF-20260410-00156/content',
        },
    ],
    history: [
        {
            achStatus: TransactionStatus.Submitted,
            dateTime: '2026-04-10T13:40:18',
            updatedBy: 'Amanda Cruz',
        },
    ],
    exportHistory: [],
}

export const NO_AUTH_TRANSACTION: TransactionDetails = {
    ...SETTLED_TRANSACTION,
    transactionId: '583914245518940099',
    processorTransactionId: 'ACH20260115583914299',
    authorizationType: null,
    authorizationDateTime: null,
    authorizationReference: null,
    authorizationReferenceDate: null,
}

export const RETURN_TYPE_TRANSACTION: TransactionDetails = {
    ...RETURNED_TRANSACTION,
    transactionId: '604827319042760099',
    processorTransactionId: 'ACH20260210604827399',
    transactionType: 'Return',
}

export const SCENARIOS = [
    { key: 'settled', label: 'Settled (Happy Path)', color: 'green' },
    { key: 'returned', label: 'Returned', color: 'red' },
    { key: 'refund', label: 'With Refunds', color: 'blue' },
    { key: 'noc', label: 'With NOC', color: 'amber' },
    { key: 'multi', label: 'Multi-Dynamic', color: 'purple' },
    { key: 'no-auth', label: 'No Authorization', color: 'gray' },
    { key: 'refund-txn', label: 'Refund Type (Suppressed)', color: 'orange' },
    { key: 'return-txn', label: 'Return Type (Suppressed)', color: 'rose' },
] as const

export const SCENARIO_MAP: Record<string, TransactionDetails> = {
    settled: SETTLED_TRANSACTION,
    returned: RETURNED_TRANSACTION,
    refund: WITH_REFUND_TRANSACTION,
    noc: WITH_NOC_TRANSACTION,
    multi: MULTI_DYNAMIC_TRANSACTION,
    'no-auth': NO_AUTH_TRANSACTION,
    'refund-txn': REFUND_SETTLED,
    'return-txn': RETURN_TYPE_TRANSACTION,
}

export const ALL_TRANSACTIONS: TransactionDetails[] = [
    SETTLED_TRANSACTION,
    RETURNED_TRANSACTION,
    WITH_REFUND_TRANSACTION,
    WITH_NOC_TRANSACTION,
    MULTI_DYNAMIC_TRANSACTION,
    SETTLED_PREVIOUS_PAYMENT,
    REFUND_SETTLED,
    REFUND_PENDING,
    MULTI_REFUND_SETTLED,
    MULTI_PREVIOUS_PAYMENT,
    MULTI_REFUND_PENDING,
    NO_AUTH_TRANSACTION,
    RETURN_TYPE_TRANSACTION,
]
